import React from "react";
import { Grid } from "@mui/material";
import { CurrencyWithPrice } from "../CurrencyWithPrice";
import { Price } from "./types";
import QuantityTextField from "./QuantityTextField";

export type CustomQuantityFieldProps = {
  price: Price | null;
  locale: string;
  moq: number;
  quantity: number;
  quantityError?: boolean;
  handleCustomQuantity: (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;

  translations: {
    quantityLabel: string;
    quantityHelperText: string;
  };
};

const CustomQuantityField: React.FC<CustomQuantityFieldProps> = (
  props: CustomQuantityFieldProps
) => {
  const { price, locale, moq, quantity, handleCustomQuantity } = props;
  return (
    <Grid
      container
      alignItems="center"
      sx={{ marginTop: 2, pl: { xs: 0, md: "23px" } }}
    >
      <Grid item xs={8}>
        <QuantityTextField
          error={props.quantityError}
          label={props.translations.quantityLabel}
          defaultValue={quantity}
          type="number"
          onChange={(
            ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => Number(ev.target.value) >= moq && handleCustomQuantity(ev)}
          inputProps={{
            step: 1,
            inputMode: "numeric",
            min: moq,
          }}
          helperText={props.translations.quantityHelperText.replace(
            "{{moq}}",
            props.moq.toString()
          )}
        />
      </Grid>
      <Grid item xs={4} sx={{ textAlign: "center", mt: "-20px" }}>
        <CurrencyWithPrice
          locale={locale}
          price={price?.price || null}
          currencyCode={price?.currencyCode || ""}
        />
      </Grid>
    </Grid>
  );
};

export default CustomQuantityField;
